var render = function render(){var _vm=this,_c=_vm._self._c;return _c('o-card',{staticClass:"col-lg-12",attrs:{"enable-back":true,"title":_vm.$t('medtastic.impressum')}},[_c('div',{staticClass:"pb-3",domProps:{"innerHTML":_vm._s(_vm.$t('medtastic.impressum_text'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }